import {
  Component,
  EventEmitter,
  Input,
  Output,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'sigecom-new-modal',
  template: `
    <div
      class="bg-sigecom-modal-dark fixed inset-0 w-full h-full z-[120] flex justify-center items-center p-4"
      *ngIf="open"
      (click)="clickOutside ? toggleModal() : null"
    >
      <div
        class="relative flex flex-col w-[calc(100vw-4rem)] md:w-[calc(100vw-16rem)] max-w-6xl max-h-[80vh] min-h-[5rem] bg-white overflow-hidden rounded-xl animate-open-modal"
        (click)="$event.stopPropagation()"
      >
        <div
          *ngIf="metadata"
          class="w-full absolute top-0 py-4 z-10 flex justify-between items-center px-5"
        >
          <p class="text-lg font-semibold ml-1 text-sigecom-gray">
            {{ metadata }}
          </p>

          <fa-icon
            icon="xmark"
            (click)="toggleModal()"
            class="text-xl text-sigecom-gray mr-2 cursor-pointer"
            *ngIf="showCloseButton"
          ></fa-icon>
        </div>

        <div
          *ngIf="!metadata && showCloseButton"
          class="absolute right-4 top-4 z-40 text-xl cursor-pointer"
        >
          <fa-icon
            icon="xmark"
            class="text-sigecom-gray"
            (click)="toggleModal()"
          ></fa-icon>
        </div>

        <div
          [ngClass]="{ 'mt-12': metadata }"
          class="w-full overflow-x-hidden overflow-y-auto flex-1 p-5"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
})
export class NewModalComponent {
  @Input() metadata?: string;
  @Input() open: boolean = false;
  @Input({ transform: booleanAttribute }) clickOutside: boolean = false;
  @Output() modalStateChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Input() showCloseButton: boolean = true;
  @Input() closeButtonClass: string = 'text-black'; // cor padrão
  @Input() alternativeStyle: boolean = false;

  constructor() {}

  toggleModal() {
    this.open = !this.open;
    this.modalStateChange.emit(this.open);
  }

  closeModal() {
    this.open = false;
    this.modalStateChange.emit(this.open);
  }
}
